import React, { useState } from "react";
import { Link, useLoaderData } from "react-router-dom";
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import AuthLayout, { AuthField } from "../../modules/AuthLayout";
import { send, notify } from "../../../services/NotificationService";
import { updatePassword } from "../../../data/auth.service";

export async function loader({ params }) {
    const email = params.email;
    const token = params.token;

    return { email, token };
}

export default function NewPassword() {
    const { email, token } = useLoaderData();
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            password: '',
            confirm: '',
            token: token,
            email: email
        },
        validate: (data) => {
            const errors = {};
            if (!data.password) {
                errors.password = "Veuillez choisir un mot de passe.";
            }
            if (!data.confirm) {
                errors.confirm = "Veuillez confirmer le mot de passe.";
            } else if (data.password !== data.confirm) {
                errors.confirm = "Les mots de passe ne correspondent pas.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setLoading(true);
            try {
                const ret = await updatePassword(data);
                if (ret.status === "500" || ret.status === 500) {
                    send("error", ret.message);
                    notify();
                    setLoading(false);
                    return;
                }
                send("success", ret.message || "Votre mot de passe a été modifié.");
                notify();
                window.location.replace('/login');
            } catch (error) {
                send("error", "La modification a échoué. Le lien a peut-être expiré.");
                notify();
                setLoading(false);
            }
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    return (
        <AuthLayout
            title="Nouveau mot de passe"
            subtitle={email ? `Choisissez un nouveau mot de passe pour ${email}.` : "Choisissez un nouveau mot de passe."}
        >
            <form onSubmit={formik.handleSubmit} noValidate>
                <AuthField
                    id="password"
                    label="Nouveau mot de passe"
                    help="Au moins 6 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial."
                    error={isFormFieldInvalid('password') ? formik.errors.password : null}
                >
                    <Password
                        inputId="password"
                        name="password"
                        autoComplete="new-password"
                        value={formik.values.password}
                        data-cy="passwordInput"
                        feedback={false}
                        toggleMask
                        onChange={(e) => formik.setFieldValue('password', e.target.value)}
                        className={classNames({ 'p-invalid': isFormFieldInvalid('password') })}
                    />
                </AuthField>

                <AuthField id="confirm" label="Confirmation du mot de passe" error={isFormFieldInvalid('confirm') ? formik.errors.confirm : null}>
                    <Password
                        inputId="confirm"
                        name="confirm"
                        autoComplete="new-password"
                        value={formik.values.confirm}
                        data-cy="passwordConfirmInput"
                        feedback={false}
                        toggleMask
                        onChange={(e) => formik.setFieldValue('confirm', e.target.value)}
                        className={classNames({ 'p-invalid': isFormFieldInvalid('confirm') })}
                    />
                </AuthField>

                <div className="lk-auth__actions">
                    <Button type="submit" label="Enregistrer le mot de passe" icon="pi pi-check" loading={loading} data-cy="connexionBtn" />
                </div>

                <div className="lk-auth__links">
                    <Link to="/login">
                        <i className="pi pi-arrow-left" aria-hidden="true"></i>
                        Retour à la connexion
                    </Link>
                </div>
            </form>
        </AuthLayout>
    );
}
